import React, { useCallback } from 'react';
import ContentSortingTypes from '../../../../model/ContentSortingTypes';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import SelectBox from '../base/SelectBox';
import useT from '../../utils/Translations/useT';
import styles from './ContentSortingSelector.scss';
const ContentSortingSelector = ({ onChange, value, ...props }) => {
    const t = useT();
    const { options } = useEnumerableModel(ContentSortingTypes);
    const handleStatusChange = useCallback(value => onChange && onChange(value), [
        onChange,
    ]);
    return (<SelectBox isFilterBar menuClassName={styles.menu} options={options} title={t('Sort')} value={value} onChange={handleStatusChange} {...props}/>);
};
export default ContentSortingSelector;
